export const network = {
    title: 'ネットワーク',
    tooltip:
        '指定した企業及び特定の企業（競合やアライアンス候補先）の社内での発明者ネットワークを表示することができます。開発の中心性が高い発明者を特定することができて、専門家インタビューや採用人材の候補者を見つけることも可能です。また、アライアンス先の開発中心人物を特定して知財DDの表明保証を検討することも可能です。また、特定の企業において、注力している開発テーマ（技術クラスタ）ごとに発明者人口又は、スコアや特許出願件数を時系列に表示されるため、これらから推定される、特定企業のR&Dロードマップを把握することができます。',
    clustersCount: 'クラスタ数',
    researcher: '発明者',
    centrality: '開発中心性',
    companyName: '企業名',
    cluster: 'クラスタ',
    chart1Title: '選択した企業の発明者ネットワーク',
    chart2Title: '競合他社の発明者ネットワーク',
    chart3Title: 'クラスタの発明者ネットワーク',
    chart4Title: 'R＆Dロードマップ',
    chart4ButtonSelectAll: '一括選択',
    chart4ButtonUnSelectAll: '一括選択解除',

    year: '年',
    numberofinventors: '発明者数',
    process: 'プロセス',
    ipcName: '技術区分'
}
